// pwr.context.ts
import { createContext } from 'react';
import PwrService from './pwr.service';
//@ts-expect-error initialize on App Init
const PwrSvcContext = createContext<PwrService>();

export default PwrSvcContext;